import React from "react";
import { Modal, ModalBuilder, Table } from "@redriver/cinnamon";
import { rejectClientAuthorisedSignatory } from "features/Companies/Customers/Signatories/Actions/actions";

const RejectSignatory = ({ signatoryId, clientId, forceUpdate }) => {
  return (
    <ModalBuilder
      withForm
      submitAction={rejectClientAuthorisedSignatory}
      submitParams={{ signatoryId, clientId }}
      onSubmitted={forceUpdate}
      loadParams={{ signatoryId, clientId }}
      renderTrigger={(showModal) => (
        <Table.MenuItem onClick={showModal}>Reject</Table.MenuItem>
      )}
      renderModal={(modalProps, formProps) => (
        <Modal.Edit
          {...modalProps}
          header="Reject Signatory"
          submitLabel="Reject"
        >
          <span>Are you sure you would like to reject this signatory?</span>
        </Modal.Edit>
      )}
    />
  );
};
export default RejectSignatory;
